import React from 'react'
import AboutUs from '../components/AboutUs'
import ContactUs from '../components/ContactUs'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'

const Contact = () => {
    return (
        <>
            <Navbar />
            <ContactUs />
            <Footer />
        </>
    )
}

export default Contact
